export const initialTransactions = [
  { id: '1',  date: '2026-04-01', amount: 5000, category: 'Salary',         type: 'income',  description: 'Monthly salary' },
  { id: '2',  date: '2026-03-28', amount: 1200, category: 'Rent',           type: 'expense', description: 'Monthly rent payment' },
  { id: '3',  date: '2026-03-25', amount: 350,  category: 'Groceries',      type: 'expense', description: 'Weekly grocery shopping' },
  { id: '4',  date: '2026-03-20', amount: 150,  category: 'Entertainment',  type: 'expense', description: 'Movie and dinner' },
  { id: '5',  date: '2026-03-15', amount: 2000, category: 'Freelance',      type: 'income',  description: 'Client project payment' },
  { id: '6',  date: '2026-03-12', amount: 80,   category: 'Transportation', type: 'expense', description: 'Gas and parking' },
  { id: '7',  date: '2026-03-10', amount: 200,  category: 'Utilities',      type: 'expense', description: 'Electricity and water' },
  { id: '8',  date: '2026-03-05', amount: 500,  category: 'Shopping',       type: 'expense', description: 'Clothing and accessories' },
  { id: '9',  date: '2026-03-01', amount: 5000, category: 'Salary',         type: 'income',  description: 'Monthly salary' },
  { id: '10', date: '2026-02-28', amount: 1200, category: 'Rent',           type: 'expense', description: 'Monthly rent payment' },
  { id: '11', date: '2026-02-25', amount: 300,  category: 'Groceries',      type: 'expense', description: 'Weekly grocery shopping' },
  { id: '12', date: '2026-02-20', amount: 120,  category: 'Entertainment',  type: 'expense', description: 'Concert tickets' },
  { id: '13', date: '2026-02-15', amount: 1500, category: 'Freelance',      type: 'income',  description: 'Consulting work' },
  { id: '14', date: '2026-02-10', amount: 90,   category: 'Transportation', type: 'expense', description: 'Monthly transit pass' },
  { id: '15', date: '2026-02-05', amount: 180,  category: 'Utilities',      type: 'expense', description: 'Internet and phone' },
];

export const categories = {
  income: ['Salary', 'Freelance', 'Investment', 'Business', 'Other Income'],
  expense: [
    'Rent', 'Groceries', 'Entertainment', 'Transportation',
    'Utilities', 'Shopping', 'Healthcare', 'Education', 'Other Expense',
  ],
};

export const categoryColors = {
  Salary:         '#10b981',
  Freelance:      '#3b82f6',
  Investment:     '#8b5cf6',
  Business:       '#f59e0b',
  'Other Income': '#6366f1',
  Rent:           '#ef4444',
  Groceries:      '#f97316',
  Entertainment:  '#ec4899',
  Transportation: '#14b8a6',
  Utilities:      '#8b5cf6',
  Shopping:       '#f59e0b',
  Healthcare:     '#06b6d4',
  Education:      '#6366f1',
  'Other Expense':'#64748b',
};
